import { render, staticRenderFns } from "./FileCheckbox.vue?vue&type=template&id=54d77706&scoped=true"
import script from "./FileCheckbox.vue?vue&type=script&lang=js"
export * from "./FileCheckbox.vue?vue&type=script&lang=js"
import style0 from "./FileCheckbox.vue?vue&type=style&index=0&id=54d77706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d77706",
  null
  
)

export default component.exports